import React from "react";
import { useNewsletterSignup } from "~/hooks/useNewsletterSignup";

const NewsletterSignup: React.FC = () => {
  const { error, clearError, isSubmitting, isSuccess, subscribe } =
    useNewsletterSignup();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = new FormData(event.currentTarget);

    subscribe(String(form.get("newsletterEmail") ?? ""));
  };

  if (isSuccess) {
    return (
      <div className="flex w-full flex-wrap items-start justify-center gap-x-2.5 gap-y-1 bg-white300 py-5">
        <div className="px-5.5 py-2.5 text-center text-lg font-bold text-green100">
          You&apos;re signed up!
        </div>
      </div>
    );
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="flex w-full flex-wrap items-start justify-center gap-x-2.5 gap-y-1 bg-white300 py-5"
    >
      <h4 className="w-full text-center text-sm text-black">
        Sign up to receive news and special offers.
      </h4>
      <div className="w-[200px]">
        <input
          id="newsletterEmail"
          name="newsletterEmail"
          className={`h-9 w-full rounded ${
            error ? "border border-red100" : "border"
          } pl-2`}
          aria-label="Email Address"
          placeholder="Email Address"
          type="email"
          onChange={() => error && clearError()}
          onFocus={clearError}
        />
        {error ? (
          <p className="mt-1 w-full text-sm text-red100">{error}</p>
        ) : null}
      </div>
      <button
        className="h-9 rounded-md bg-blue px-4 uppercase text-white enabled:hover:bg-blue200 disabled:bg-gray"
        name="button"
        type="submit"
        disabled={Boolean(error) || isSubmitting}
      >
        Sign Up
      </button>
    </form>
  );
};

export default NewsletterSignup;
